import Vue from "vue";
import Site from "./Site.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import VueTagManager from "vue-tag-manager";
import VueNotification from "vue-notification";
import VueMeta from "vue-meta";
import VueSocialSharing from 'vue-social-sharing'

Vue.config.productionTip = false;

store.subscribeAction((action, state) => {
  console.log(action.type);
  console.log(action.payload);
});

Vue.use(VueTagManager, {
  gtmId: "GTM-NLWHFWF"
});
Vue.use(VueNotification);
Vue.use(VueMeta);
Vue.use(VueSocialSharing);

// Vue.use(VueFacebookPixel);
// Vue.analytics.fbq.init(295543084958473);

// Vue.use(VueResizeText);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(Site)
}).$mount("#app");
